import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const ScheduleListSkeleton: React.FC = () => {
  return (
    <div>
      <div className="py-2 flex items-center gap-3">
        <Skeleton className="h-8 w-24" />
        <Skeleton className="h-8 w-64" />
        <Skeleton className="ml-auto h-8 w-32" />
      </div>
      <div className="space-y-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-full" />
        ))}
      </div>
    </div>
  )
}
export default ScheduleListSkeleton
